var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: Boolean(_vm.error),
          expression: "Boolean(error)",
        },
      ],
      staticClass: "partialErrorArea",
      class: { isPc: !_vm.isSp },
    },
    [_c("p", { staticClass: "partialError" }, [_vm._v(_vm._s(_vm.error))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }